import { render, staticRenderFns } from "./DutiesAndTaxes.vue?vue&type=template&id=04b345a4&scoped=true&"
import script from "./DutiesAndTaxes.vue?vue&type=script&lang=js&"
export * from "./DutiesAndTaxes.vue?vue&type=script&lang=js&"
import style0 from "./DutiesAndTaxes.vue?vue&type=style&index=0&id=04b345a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b345a4",
  null
  
)

export default component.exports